import * as React from 'react';
import PersistentIframeController from 'src/components/persistent-iframe/persistent-iframe-controller';
import DocumentTitle from 'react-document-title';
import Navbar from 'src/common/Navbar/Navbar';
import { CustomFrontendMenuEntry } from './customFrontendManifest';

interface Props {
  menuEntry: CustomFrontendMenuEntry;
}

const CustomFrontendHost = ({ menuEntry }: Props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <DocumentTitle title={menuEntry.label} />
      <Navbar title={menuEntry.label} />
      <PersistentIframeController
        route={menuEntry.iframeRoute}
        appName={menuEntry.appId}
        key={menuEntry.id}
      />
    </div>
  );
};

export default CustomFrontendHost;
